export const AuthMechanism = {
  password: 'password',
  google: 'google',
  facebook: 'facebook',
  creditkarma: 'creditkarma',
  cityOfAlexandria: 'cityOfAlexandria',
  adp: 'adp',
  oidc: 'oidc',
};
